import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { EmptyState, ErrorBox, PageHeader, Spinner } from "@/components/Bits";

export default function Notifications() {
  const { tz } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/me/notifications").then(({ data }) => { setData(data); if (data.unread) api.post("/me/notifications/read"); }).catch((e) => setError(errMsg(e)));
  }, []);
  return (
    <div>
      <PageHeader eyebrow="Dans l'application" title="Notifications" />
      {error && <ErrorBox message={error} />}
      {!data && !error && <Spinner />}
      {data && (data.items.length ? (
        <div className="mpl-card divide-y divide-white/[0.05]" data-testid="notifications-list">
          {data.items.map((n) => (
            <Link key={n.id} to={n.link || "#"} className="flex gap-3 px-4 py-3 hover:bg-white/[0.03]" data-testid={`notification-${n.id}`}>
              <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${n.read ? "bg-transparent" : "bg-[#B7F52A]"}`} />
              <span className="min-w-0">
                <span className="block text-sm font-semibold">{n.title}</span>
                <span className="block text-sm text-slate-400">{n.body}</span>
                <span className="block text-xs text-slate-500">{fmtDateTime(n.created_at, tz)}</span>
              </span>
            </Link>
          ))}
        </div>
      ) : <EmptyState icon={Bell} title="Aucune notification" text="Rappels, résultats et invitations apparaîtront ici." testId="notifications-empty" />)}
    </div>
  );
}
